import { Component, EventEmitter, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import * as _ from 'lodash';
import { mergeMap } from 'rxjs/operators';
import { IntegrationDao } from '../../../../core/services/dao/integrationDao';
import { User } from '../../../../core/models/user';
import { IntegrationInvite } from '../../../../core/models/integrationInvite';

@Component({
  selector: 'google-analytics-reporting',
  templateUrl: './google-analytics-reporting.component.html',
  styleUrls: ['./google-analytics-reporting.component.scss']
})
export class GoogleAnalyticsReportingComponent implements OnInit, OnDestroy {
  private subs = [];

  loading = false;

  viewOptions = [];
  selectedView;
  oauthURL = '';
  existingIntegrations = [];
  createdIntegration: any = {};
  creating = false;

  errorMsg = '';
  user: User;
  invites: IntegrationInvite[];
  description: string = '';
  showAccounts = false;
  integrationName;
  integrationType;
  noAccounts = false;
  isAdmin = false;
  emitter: EventEmitter<any>;

  constructor(
    public dialogRef: MatDialogRef<GoogleAnalyticsReportingComponent>,
    public integrationDao: IntegrationDao,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.existingIntegrations = this.data.existingIntegrations;
    this.user = this.data.user;
    this.isAdmin = this.user ? this.user.isAdmin : false;
    this.invites = this.data.invites.filter(i => i.integrations.includes(this.data.type));
    this.description = this.data.description;
    this.integrationName = this.data.name;
    this.integrationType = this.data.type;
    this.emitter = this.data.emitter;
    if (this.existingIntegrations.length === 0) {
      this.creating = true;
      this.noAccounts = true;
    }
    // let sub = this.integrationDao.getGoogleAnalyticsOAuthUrl(this.data.brand).subscribe(res => {
    //   this.oauthURL = res['url'];
    // });
   // this.subs.push(sub);
  }

  ngOnInit(): void {}

  toggleShowAccounts() {
    this.showAccounts = !this.showAccounts;
  }

  onViewInvitesClick() {
    this.emitter.emit(this.integrationType);
    this.dialogRef.close();
  }

  ngOnDestroy() {
    this.subs.forEach(sub => sub.unsubscribe());
    if (this.createdIntegration && this.createdIntegration.id && !this.createdIntegration.viewId) {
      // this.integrationDao.disconnect(this.createdIntegration.id).subscribe(() => {
      //   console.log('successfully removed integration');
      // });
    }
  }

  onClick(e) {
    if (!this.oauthURL) {
      console.error('OAuth URL not loaded');
      return false;
    }
    let opened = window.open(this.oauthURL, null, 'width=800,height=850,modal=yes,alwaysRaised=yes');

    let listener = event => {
      if (event.data) {
        if (event.data.type && event.data.type === 'google_analytics' && event.data.id !== undefined) {
          this.loading = true;
          this.integrationDao
              .loadById(event.data.id)
              .pipe(
                  // mergeMap(res => {
                  //   this.createdIntegration = res;
                  //   return this.integrationDao.getGoogleAnalyticsViews(this.createdIntegration.id);
                  // })
              )
              .subscribe(views => {
                this.listViewsSetState(views);
              });

          // remove listener
          window.removeEventListener('message', listener);

          // close window
          opened.close();
        }
      }
    }

    window.addEventListener('message', listener);
  }

  addAnother(e) {
    this.creating = true;
  }

  selectView(e) {
    let updates = {
      type: 'google_analytics_reporting',
      enabled: true,
      viewId: this.selectedView.id,
      viewName: this.selectedView.name,
      viewTimezone: this.selectedView.timezone,
      webPropertyId: this.selectedView.webPropertyId,
      accountId: this.selectedView.accountId,
      friendlyName: this.selectedView.name
    };
    // this.integrationDao.update(this.createdIntegration.id, updates).subscribe(res => {
    //   this.createdIntegration = res;
    //   this.createdIntegration.viewId = this.selectedView.id;
    //   this.createdIntegration.friendlyName = res.friendlyName;
    //   this.dialogRef.close(this.createdIntegration);
    // });
  }

  private listViewsSetState(loadedViews: any): void {
    if (loadedViews && loadedViews.data) {
      const items = _.map(loadedViews.data.items, i => {
        return {
          id: i.id,
          webPropertyId: i.webPropertyId,
          name: i.name,
          timezone: i.timezone,
          accountId: i.accountId
        };
      });

      const grouped = _.groupBy(items, 'webPropertyId');
      this.viewOptions = _.map(grouped, (value, key) => {
        return {
          name: key,
          views: value
        };
      });
      this.errorMsg = '';
    }

    if (this.viewOptions.length === 0) {
      this.errorMsg = 'No Views Found. Try a different Google Account';
      console.log(this.createdIntegration);
      if (this.createdIntegration && this.createdIntegration.id) {
        // this.integrationDao.disconnect(this.createdIntegration.id).subscribe(() => {
        //   console.log('successfully removed integration');
        //   this.createdIntegration = null;
        // });
      }
    }
    this.loading = false;

  }
}
